import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './auth/login/login.component';
import { CoreRoutingModule } from "./core-routing.module";
import { ThirdFormStepComponent } from './etablissement/components/third-form-step/third-form-step.component';
import { SecondFormStepComponent } from './etablissement/components/second-form-step/second-form-step.component';
import { FirstFormStepComponent } from './etablissement/components/first-form-step/first-form-step.component';
import { SharedModule } from '../shared/shared.module';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { EtablissementComponent } from './etablissement/etablissement.component';
import { FinalFormStepComponent } from './etablissement/components/final-form-step/final-form-step.component';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { NewPasswordComponent } from './auth/new-password/new-password.component';
import { ForgetPasswordComponent } from './auth/forget-password/forget-password.component';
import { NgxIntlTelInputModule } from "@justin-s/ngx-intl-tel-input";
import { CandidatComponent } from './candidat/candidat.component';
import { FirstStepCandidatComponent } from './candidat/components/first-step-candidat/first-step-candidat.component';
import { SecondStepCandidatComponent } from './candidat/components/second-step-candidat/second-step-candidat.component';
import { ThirdStepCandidatComponent } from './candidat/components/third-step-candidat/third-step-candidat.component';
import { AgencySignupComponent } from './agency/agency-signup/agency-signup.component';
import { ComponentsComponent } from './agency/agency-signup/components/components.component';
import { AgencyUsersComponent } from './agency/agency-users/agency-users.component';
import { AddUserComponent } from './agency/agency-users/add-user/add-user.component';
import { AgencyManagementComponent } from './agency/agency-management/agency-management.component';
import { AddAgencyComponent } from './agency/agency-management/add-agency/add-agency.component';
import { DetailsUserComponent } from './agency/agency-users/details-user/details-user.component';
import { DetailsAgencyComponent } from './agency/agency-management/details-agency/details-agency.component';
import { MissionsManagementComponent } from './agency/missions-management/missions-management.component';
import { AddCandidateDialogComponent } from './agency/agency-candidates/add-candidate-dialog/add-candidate-dialog.component';
import { AgencyDirectAssignComponent } from './agency/agency-direct-assign/agency-direct-assign.component';


@NgModule({
  declarations: [
    LoginComponent,
    ThirdFormStepComponent,
    SecondFormStepComponent,
    FirstFormStepComponent,
    EtablissementComponent,
    FinalFormStepComponent,
    ForgotPasswordComponent,
    NewPasswordComponent,
    FinalFormStepComponent,
    ForgetPasswordComponent,
    CandidatComponent,
    FirstStepCandidatComponent,
    SecondStepCandidatComponent,
    ThirdStepCandidatComponent,
    AgencySignupComponent,
    ComponentsComponent,
    AgencyUsersComponent,
    AddUserComponent,
    AgencyManagementComponent,
    AddAgencyComponent,
    DetailsUserComponent,
    DetailsAgencyComponent,
    MissionsManagementComponent,
    AgencyDirectAssignComponent,
  ],
  imports: [
    CommonModule,
    CoreRoutingModule,
    SharedModule,
    AngularSvgIconModule.forRoot(),
    NgxIntlTelInputModule,
  ],
  exports: [
    ThirdStepCandidatComponent

  ],
  // providers: [
  //   {
  //     provide: HTTP_INTERCEPTORS,
  //     useClass: AuthenticationInterceptor,
  //     multi: true
  //   }
  // ]
})
export class CoreModule { }
